import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import Table from "../../../components/common/table/Table";
import { matchKeywordGroupsList } from "../../../graphql/queries/listKeywordGroups";
import "../../jsonForms/activityRuleSetup/Products/productsPointsSelect/products-points-select.scss";

const MatchKeywordsViewComponent = ({ data, inputSchema, filterBy }) => {
  const filter_by = inputSchema?.properties?.ids?.filter_by || filterBy || "BRAND";
  const { data: keywordGroupsList } = useQuery(matchKeywordGroupsList, {
    variables: { type: filter_by },
    fetchPolicy: "cache-first",
  });

  const formattedGroups = useMemo(() => {
    const formattedSelectedGroups = [];
    const selectedIds = data?.ids || [];
    if (selectedIds?.length && keywordGroupsList?.listKeywordGroups?.length) {
      selectedIds.forEach((id) => {
        const formattedGroup = keywordGroupsList?.listKeywordGroups?.find(
          (keywordGroup) => keywordGroup.id === id
        );
        if (formattedGroup) {
          formattedSelectedGroups.push(formattedGroup);
        }
      });
      return formattedSelectedGroups;
    }
  }, [data, keywordGroupsList]);

  const getSelectedLabel = (filter_by) => {
    if (filter_by === "OUTLET") {
      return "Selected Retailers";
    }
    if (filter_by === "PRODUCT") {
      return "Participating Products";
    }
    return "Selected Brands";
  };

  const headerData = [
    { columnKey: "product", header: "PRODUCT" },
    { columnKey: "sku", header: "SKU" },
  ];

  const rowData =
    formattedGroups?.map((group) => ({
      product: group.name,
      sku: group.keywords?.[0] || "-",
    })) || [];

  if (filter_by === "PRODUCT") {
    if (!formattedGroups?.length) {
      return (
        <div className="additional-fields-container" style={{ width: "100%" }}>
          <span className="field-value">-</span>
        </div>
      );
    }

    return (
      <div className="products-points-sets w-100" style={{ marginTop: "16px" }}>
        <div className="products-points-details">
          <div className="products-points-header">
            <span className="font-body-bold">
              {getSelectedLabel(filter_by)} ({formattedGroups.length})
            </span>
          </div>
          <div className="products-details-container">
            <Table
              headerData={headerData}
              rowData={rowData}
              pagination={true}
              rowsPerPage={10}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="additional-fields-container">
      <div className="field-pair" style={{ flexBasis: "31% !important" }}>
        <span className="field-label">{getSelectedLabel(filter_by) + " :"}</span>
      </div>
      <div className="field-pair-two-column">
        <span className="field-value">
          {formattedGroups?.length
            ? formattedGroups.map((brand) => brand.name).join(", ")
            : "-"}
        </span>
      </div>
    </div>
  );
};

export default MatchKeywordsViewComponent;
